export enum View {
  Organization = "organizationView",
  Donor = "donorView",
}
